import { createSlice } from "@reduxjs/toolkit";

export const userDetailsSlice = createSlice({
    name: "userDetails",
    initialState: {
        fullName: null,
        mobileNumber: null,
        pvpbFlag: null,
        cifId: null,
        idNumber: null,
        mob_islogin: "Pre Login",
    },
    reducers: {
        setFullName: (state, action) => {
            state.fullName = action.payload;
        },
        setMobileNumber: (state, action) => {
            state.mobileNumber = action.payload;
        },
        setPvPbFlag: (state, action) => {
            state.pvpbFlag = action.payload;
        },
        setCifId: (state, action) => {
            state.cifId = action.payload;
        },
        setIdNumber: (state, action) => {
            state.idNumber = action.payload;
        },
        setMobIsLogin: (state, action) => {
            state.mob_islogin = action.payload;
        },
    }
});

export const { setFullName, setMobileNumber, setPvPbFlag, setCifId, setIdNumber, setMobIsLogin } = userDetailsSlice.actions;

export default userDetailsSlice.reducer;
